import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OvertimesLine  {
    _originalTypeClassName = "zERP.BO.OvertimesLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OvertimesLine.translate = translateService;
}
this.OvertimeRequests = [];
this.OvertimeDate = null;
this.SumOvertimes = null;
this.OvertimesLineKey = null;
this._key = this.OvertimesLineKey = 0; 
}

static translate: TranslateService;
_key: any;
OvertimeDate:any;
SumOvertimes:any;
OvertimeRequests:any;
Employee:any;
OvertimesTable:any;
private _OvertimesLineKey:any;
get OvertimesLineKey(): any {
    return this._OvertimesLineKey;
  }
set OvertimesLineKey(value: any) {
    this._OvertimesLineKey = value;
    this._key = value;
  }
static setOvertimeRequests = ($this, items) => {
                if (items == null) items = [];
                if ($this.OvertimeRequests == null) $this.OvertimeRequests = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OvertimeRequests.length > 0) {
                    Domain.OvertimesLine.removeOvertimeRequests($this, $this.OvertimeRequests[0]);
                }

                Domain.OvertimesLine.addManyOvertimeRequests($this, copyItems);
            }
static addManyOvertimeRequests = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OvertimesLine.addOvertimeRequests($this, items[i]);
                }
            }
static addOvertimeRequests = ($this, item) => {
                if ($this.OvertimeRequests == null) $this.OvertimeRequests = [];
                if (item == null || $this.OvertimeRequests.indexOf(item) > -1) return;
                $this.OvertimeRequests.push(item);
}
static addRangeOvertimeRequests = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OvertimesLine.addOvertimeRequests($this, item));
            }
static removeOvertimeRequests = ($this, item) => {
                if ($this == null || $this.OvertimeRequests == null || $this.OvertimeRequests.indexOf(item) === -1) return;
                var _index = $this.OvertimeRequests.indexOf(item);
                $this.OvertimeRequests.splice(_index, 1);
}
static clearOvertimeRequests = ($this) => { $this.OvertimeRequests = null; }
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setOvertimesTable = ($this, value) => {
var oldValue = $this.OvertimesTable;
$this.OvertimesTable = value;
if (value != null) {
if (oldValue != null) {
Domain.OvertimesTable.removeOvertimesLines(oldValue, $this);
}
Domain.OvertimesTable.addOvertimesLines(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OvertimesLineKey == null || $this.OvertimesLineKey == 0;
            }


}